import React, { createContext, useContext, useState, useEffect } from "react";
import axiosInstance from "../Config/axios";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import Loader from "../Components/Loader/Loader";

const ListSportsContext = createContext();
export const useListSports = () => useContext(ListSportsContext);

export const ListSportsProvider = ({ children }) => {
  
  const [loading, setLoading] = useState(false);
  const [preferredSports, setPreferredSports] = useState(null);
  const [allSports, setAllSports] = useState(null);
  const navigate = useNavigate();




  const fetchPreferedSportsbyType = async (type) => {
    setLoading(true);
    try {
      const response = await axiosInstance.get(`/scheduler/get_all_sports/?sport_type=${type}`);
      setAllSports(response.data.all);
      setPreferredSports(response.data.preferred);
      
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Failed",
        text: `Failed to fetch sports!`,
        confirmButtonColor: "#B79527", // orange / gold
      cancelButtonColor: "#1C1C1C",
      });
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  

  
  
  return (
    <ListSportsContext.Provider value={{ fetchPreferedSportsbyType, preferredSports, allSports }}>
      {loading && (
       <Loader/>
      )}
      {children}
    </ListSportsContext.Provider>
  );
};
